<template>
	<div class="auth d-flex justify-content-center align-items-center">
		<div class="auth__form theme-bg">
			<h3 class="py-2 pl-4 auth__form__heading text-light">
				Reset
				<span class="auth__form__heading--span-highlight"
					>Password</span
				>
			</h3>
			<form @submit.prevent="resetPassword">
				<vs-input
					v-model.trim="resetPasswordData.password"
					color="#FAF7FD"
					required
					:visible-password="passwordVisible"
					class="auth__input-parent auth__input-parent--password my-45"
					label-placeholder="Password"
					type="password"
					icon-after
				>
					<template #icon>
						<button
							class="plain-btn"
							type="button"
							tabindex="-1"
							@click="passwordVisible = !passwordVisible"
						>
							<transition mode="out-in" name="v-scaled">
								<i
									key="locked"
									v-if="!passwordVisible"
									class="fa fa-lock"
								>
								</i>
								<i key="open" v-else class="fa fa-lock-open">
								</i>
							</transition>
						</button>
					</template>
				</vs-input>

				<vs-button
					size="large"
					color="#362EB8"
					type="submit"
					class="d-block m-auto w-50"
				>
					Reset Password
				</vs-button>
			</form>
		</div>
	</div>
</template>

<script>
import notifier from "@/components/mixins/notifier"
import axiosInstance from "@/utils/axiosConfig"

export default {
	mixins: [notifier],
	data: () => ({
		passwordVisible: false,

		resetPasswordData: {
			password: ""
		}
	}),
	methods: {
		async resetPassword() {
			const { email, token } = this.$route.params
			const {
				data: { success, msg }
			} = await axiosInstance.put(`/auth/login/reset-password/${token}`, {
				...this.resetPasswordData,
				email
			})
			if (success) {
				this.openNotification("Reset Password", msg)
				return this.$router.push({ name: "login" })
			}
		}
	}
}
</script>

<style></style>
